import { isApproved, isRejected, getRejectReasonText } from "./helper";
import { dateTimeFormater } from "../../../../../utilities/formaters";

const CollapsedComponentOffer = ({
  offerWithDecision,
  collapsed,
  setCollapsed,
}) => {
  const isAutomaticDecision = offerWithDecision.DecisionByPerson == null;
  const approveText = isAutomaticDecision
    ? `Auto-approved`
    : `Approved by ${offerWithDecision.DecisionByPerson.Name}`;

  const rejectText = isAutomaticDecision
    ? `Auto-rejected`
    : `Rejected by ${offerWithDecision.DecisionByPerson.Name}`;

  return (
    <div
      onClick={() => setCollapsed(collapsed !== true)}
      style={{ marginLeft: "2px" }}
    >
      <div style={{ color: "black", cursor: "pointer" }}>Expand</div>
      {isApproved(offerWithDecision) && (
        <div>
          {approveText}
          <br />
        </div>
      )}
      {isRejected(offerWithDecision) && (
        <div>
          {rejectText}
          <br />
          Reject reason {getRejectReasonText(offerWithDecision)}
          <br />
        </div>
      )}
      {offerWithDecision.IsSigned && (
        <div>
          Signed by user
          <br />
        </div>
      )}
      {offerWithDecision.ExpiredAt &&
        `Expired at ${dateTimeFormater(offerWithDecision.ExpiredAt)}`}
    </div>
  );
};

export default CollapsedComponentOffer;
